import { render } from "./ShopDetail.vue?vue&type=template&id=d4c13050&scoped=true"
import script from "./ShopDetail.vue?vue&type=script&lang=js"
export * from "./ShopDetail.vue?vue&type=script&lang=js"

import "./ShopDetail.vue?vue&type=style&index=0&id=d4c13050&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4c13050"]])

export default __exports__